import { catalogOf, displayName, useRegistry } from "../registry";
import type { RegistryCatalog } from "../types";

const CATALOG_CLASS: Record<RegistryCatalog, string> = {
  feature: "badge-primary",
  hardware: "badge-secondary",
  software: "badge-accent",
  program: "badge-info",
};

/**
 * A run's product area (registry keys from any catalog) as small badges, colored by
 * catalog, with the key on hover. Distinct from TagChips, which shows the union of a
 * run's coverage-target tags.
 */
export default function ProductChips({
  keys,
  empty,
}: {
  keys: string[] | undefined;
  /** Text shown when there is no product area (omit to render nothing). */
  empty?: string;
}) {
  const { data: registry } = useRegistry();
  if (!keys || keys.length === 0) {
    return empty ? <span className="text-xs opacity-50">{empty}</span> : null;
  }
  return (
    <span className="inline-flex flex-wrap gap-1 items-center">
      {keys.map((key) => {
        const catalog = catalogOf(registry, key);
        return (
          <span
            key={key}
            className={`badge badge-sm ${catalog ? CATALOG_CLASS[catalog] : "badge-ghost"}`}
            title={`Product area · ${catalog ?? "unknown"} · ${key}`}
          >
            {displayName(registry, key)}
          </span>
        );
      })}
    </span>
  );
}
